export default "__VITE_ASSET__d88bc009__"